import Api from './../api'

export default DataLayer => DataLayer.$extend('channels', {
    get() {
        return Api.channels.get()
    },
    validateStream({ token, station, mount }) {
        return Api.channels.validateStream({ token, station, mount })
    },
})
